"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureUiKit = void 0;
const config_1 = require("./config");
// eslint-disable-next-line import/prefer-default-export
const configureUiKit = (config) => {
    Object.assign(config_1.UI_KIT_CONFIG, config);
};
exports.configureUiKit = configureUiKit;
